export const LOCAL_STORAGE = {
  'dashboard-preferences': {
    utcMode: '',
    utcFrom: '',
    utcTo: '',
    utcRecentValue: 5,
    utcRecentUnit: '',
    utcFilterEnabled: true,
  },
  'filters-form-undefined': {
    lastXRecordsFilterEnabled: false,
    lastXRecords: '',
    utcFilterEnabled: true,
    utcMode: '',
    utcFrom: '',
    utcTo: '',
    utcRecentValue: 20,
    utcRecentUnit: 'd',
    sctsFilterEnabled: false,
    sctsMode: '',
    sctsFrom: '',
    sctsTo: '',
    sctsRecentValue: '',
    sctsRecentUnit: '',
    originFilterEnabled: false,
    origin: '',
    fixTypeFilterEnabled: false,
    fixType: '',
    mortalityStatusFilterEnabled: false,
    mortalityStatus: '',
    mortalityTypeFilterEnabled: false,
    mortalityType: '',
    descriptionFilterEnabled: false,
    description: '',
    groupsFilterEnabled: false,
    groups: '',
    animalNameFilterEnabled: false,
    animalName: '',
    invalidPositionsFilterEnabled: false,
    hideInvalidPositions: false,
  },
};
